import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { escape } from 'underscore';

import { VideogularComponent } from './Videogular.Component';

import styles from './VgChapterDisplay.module.less';

const defaultChapterImage = '/img/chapter-placeholder.svg';

@Component({
	selector: 'vg-chapter-display',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: '<safe-style [css]="backgroundImageStyle()"></safe-style>',
	host: {
		'[class]': 'styles.root'
	},
    standalone: false
})
export class VgChapterDisplayComponent {
	public readonly styles = styles;

	constructor(
		private vgApi: VideogularComponent
	) {}

	public readonly backgroundImageStyle = computed(() => {
		const chapter = this.vgApi.chapterHelper?.currentChapter();
		const imageUri = escape(chapter?.url || defaultChapterImage);
		// This approach is taken instead of a simpler style property binding to work around Chrome requesting the same image multiple times.
		return `
			vg-chapter-display {
				background-image: url("${imageUri}") !important;
			}
		`;
	});
}
